import { render, staticRenderFns } from "./DingFlash.vue?vue&type=template&id=1d5ff650&scoped=true&"
import script from "./DingFlash.vue?vue&type=script&lang=js&"
export * from "./DingFlash.vue?vue&type=script&lang=js&"
import style0 from "./DingFlash.vue?vue&type=style&index=0&id=1d5ff650&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5ff650",
  null
  
)

export default component.exports